import IconButton from '@/_application/core/components/ui/icon-button';
import {Image} from '@/_application/core/components/ui/image';
import {ProductLoaderHorizontal} from '@/_application/core/components/ui/loaders/product-loader';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {Product} from '@/_application/modules/products/model/product';
import {Routes} from '@/config/routes';
import {useHighlightProducts} from '@/framework/products-promotion';
import rangeMap from '@/lib/range-map';
import {useTranslation} from 'next-i18next';
import {useRouter} from 'next/router';
import {LazyLoadBlock} from '@/_application/core/components/commons/lazy-load-block';
import {useEffect} from 'react';

const BlueNextArrowIcon = getImageAssetUrl('icons/blue-next-arrow.png');

const HighlightProductsMobile = () => {
    const {t} = useTranslation();
    const {fetchHighlightProducts, highlightProducts, isLoading} = useHighlightProducts();

    const router = useRouter();

    const handleOnClick = (url: string) => {
        router.push(url);
    };

    useEffect(() => {
        fetchHighlightProducts();
    }, []);

    return (
        <>
            <div className="w-full">
                {isLoading && rangeMap(2, i => <ProductLoaderHorizontal key={i} uniqueKey={`product-${i}`} />)}

                {!!highlightProducts?.length &&
                    highlightProducts
                        ?.filter((_, index) => index < 4)
                        .map(
                            product =>
                                product?.product && (
                                    <LazyLoadBlock isLazyLoad={true}>
                                        <div key={(product?.product as {id?: number})?.id} className="mx-4 mt-4">
                                            <ProductCard
                                                product={product?.product as Product}
                                                extraIcon={product?.icon!}
                                                extraText={product?.label!}
                                                variant={'horizontal'}
                                            />
                                        </div>
                                    </LazyLoadBlock>
                                ),
                        )}
            </div>
            <div className="flex justify-center items-center">
                <IconButton
                    whileTap={{translateX: 6, backgroundColor: '#21409A', opacity: 0.5}}
                    transition={{ease: 'easeOut'}}
                    onClick={() => handleOnClick(Routes.highlightProducts)}
                    className="mx-auto mt-4 flex flex-row-reverse content-center items-center justify-center rounded-2xl px-3 py-2"
                    icon={<Image src={BlueNextArrowIcon} alt="Icon" width={7} height={11} className="ml-2" />}
                    label={t('text-load-more')}
                    labelClassName="text-primary text-xs"></IconButton>
            </div>
        </>
    );
};

export default HighlightProductsMobile;
